/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Talk_Display_NameInputs */

const en_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const id_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bicara Premium`)
};

const ms_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const ca_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversa Premium`)
};

const cs_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const da_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoopkald Premium`)
};

const de_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const et_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const es_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const fr_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appels Premium`)
};

const hr_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const it_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoconferenze Premium`)
};

const lv_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sarunas Premium`)
};

const lt_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalbėkite Premium`)
};

const hu_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videóhívás Prémium`)
};

const nl_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const nb_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const pl_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const pt_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const ro_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const sk_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const sl_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium Pogovor`)
};

const fi_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const sv_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samtal Premium`)
};

const vi_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trò chuyện Premium`)
};

const tr_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const el_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const bg_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const ru_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Премиум`)
};

const sr_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const uk_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const ka_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk პრემიუმი`)
};

const hi_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const th_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const ko_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`토크 프리미엄`)
};

const zh_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

const zh_tw_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通話高級版`)
};

const ja_talk_display_name = /** @type {(inputs: Talk_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk Premium`)
};

/**
* | output |
* | --- |
* | "Talk Premium" |
*
* @param {Talk_Display_NameInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const talk_display_name = /** @type {((inputs?: Talk_Display_NameInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Talk_Display_NameInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_talk_display_name(inputs)
	if (locale === "ms") return ms_talk_display_name(inputs)
	if (locale === "ca") return ca_talk_display_name(inputs)
	if (locale === "cs") return cs_talk_display_name(inputs)
	if (locale === "da") return da_talk_display_name(inputs)
	if (locale === "de") return de_talk_display_name(inputs)
	if (locale === "et") return et_talk_display_name(inputs)
	if (locale === "es") return es_talk_display_name(inputs)
	if (locale === "fr") return fr_talk_display_name(inputs)
	if (locale === "hr") return hr_talk_display_name(inputs)
	if (locale === "it") return it_talk_display_name(inputs)
	if (locale === "lv") return lv_talk_display_name(inputs)
	if (locale === "lt") return lt_talk_display_name(inputs)
	if (locale === "hu") return hu_talk_display_name(inputs)
	if (locale === "nl") return nl_talk_display_name(inputs)
	if (locale === "nb") return nb_talk_display_name(inputs)
	if (locale === "pl") return pl_talk_display_name(inputs)
	if (locale === "pt") return pt_talk_display_name(inputs)
	if (locale === "ro") return ro_talk_display_name(inputs)
	if (locale === "sk") return sk_talk_display_name(inputs)
	if (locale === "sl") return sl_talk_display_name(inputs)
	if (locale === "fi") return fi_talk_display_name(inputs)
	if (locale === "sv") return sv_talk_display_name(inputs)
	if (locale === "vi") return vi_talk_display_name(inputs)
	if (locale === "tr") return tr_talk_display_name(inputs)
	if (locale === "el") return el_talk_display_name(inputs)
	if (locale === "bg") return bg_talk_display_name(inputs)
	if (locale === "ru") return ru_talk_display_name(inputs)
	if (locale === "sr") return sr_talk_display_name(inputs)
	if (locale === "uk") return uk_talk_display_name(inputs)
	if (locale === "ka") return ka_talk_display_name(inputs)
	if (locale === "hi") return hi_talk_display_name(inputs)
	if (locale === "th") return th_talk_display_name(inputs)
	if (locale === "ko") return ko_talk_display_name(inputs)
	if (locale === "zh") return zh_talk_display_name(inputs)
	if (locale === "zh-tw") return zh_tw_talk_display_name(inputs)
	if (locale === "ja") return ja_talk_display_name(inputs)
	return en_talk_display_name(inputs)
});